<!-- @format -->

<template>
	<el-row :gutter="6" class="full-width">
		<el-col :span="24">
			<el-button size="small" @click="onAdd">新增</el-button>
		</el-col>
		<el-col :span="2" />
		<el-col :span="9">
			<label class="label">名称</label>
		</el-col>
		<el-col :span="10">
			<label class="label">编码</label>
		</el-col>
		<el-tree
			ref="treeRef"
			:data="value"
			node-key="id"
			draggable
			default-expand-all
			:indent="8"
			:expand-on-click-node="false"
			class="full-width"
		>
			<template #default="{ node, data }: { node: Node, data: WidgetConfigOption }">
				<el-row :gutter="6" class="full-width setting-items">
					<el-col :span="10">
						<el-input v-model="data.label" />
					</el-col>
					<el-col :span="10">
						<el-input v-model="data.value" />
					</el-col>
					<div class="setting-btns">
						<el-button type="primary" icon="Plus" link @click.stop.prevent="onAppend(data)" />
						<el-button type="primary" icon="Delete" link @click.stop.prevent="onRemove(node, data)" />
					</div>
				</el-row>
			</template>
		</el-tree>
	</el-row>
</template>

<script setup lang="ts">
	import { type ElTree } from 'element-plus';
	import { type WidgetConfigOption } from '../../types';
	import type Node from 'element-plus/es/components/tree/src/model/node';

	interface Props {
		modelValue: WidgetConfigOption[];
	}

	const props = withDefaults(defineProps<Props>(), {});

	const emit = defineEmits(['update:modelValue']);

	const treeRef = ref<InstanceType<typeof ElTree>>();

	const value = computed({
		get() {
			return props.modelValue || [];
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});

	const onAdd = () => {
		value.value.push({ value: '1', label: '1' });
	};

	const onAppend = (data: WidgetConfigOption) => {
		const newChild: WidgetConfigOption = { label: '1', value: '1', children: [] };
		if (!data.children) {
			data.children = [];
		}
		data.children.push(newChild);
	};

	const onRemove = (node: Node, data: WidgetConfigOption) => {
		const parent = node.parent;
		const children: WidgetConfigOption[] = parent.data.children || parent.data;
		const index = children.findIndex((d) => d.value === data.value);
		children.splice(index, 1);
	};
</script>

<style scoped lang="scss">
	.setting-items {
		.setting-btns {
			position: absolute;
			right: 0;

			button + button {
				margin: 0;
			}
		}
	}

	.full-width {
		width: 100%;
	}
</style>
